import { useTranslation } from 'react-i18next';

import { Button, Flex } from 'antd';

import logo from 'assets/images/logo/logo-pub.svg';
import { Logo } from 'shared/ui';

import styles from '../HeaderAdvertiser/Header.module.scss';

export const HeaderPublic = () => {
	const { t } = useTranslation();

	return (
		<Flex className={styles.header} gap={8} justify={'space-between'} align={'center'}>
			<Logo image={logo} width={88} height={50} />
			<Button type="primary">{t('Sign in')}</Button>
		</Flex>
	);
};
